import { TypeResponse } from 'gtd-ng-widget';

export class CrmQuestionsResponse extends TypeResponse {
  questions: ICrmQuestion[];
}

interface ICrmQuestion {
  answer: string | null;
  answer_id: number | null;
  question: string | null;
  question_id: number;
  required: boolean;
  answer_created_at: string;
  question_created_at: string;
}
